import { render } from "./ProductBarcodeView.vue?vue&type=template&id=07b43d93&scoped=true"
import script from "./ProductBarcodeView.vue?vue&type=script&lang=js"
export * from "./ProductBarcodeView.vue?vue&type=script&lang=js"

import "./ProductBarcodeView.vue?vue&type=style&index=0&id=07b43d93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b43d93"]])

export default __exports__